import { useRef, useEffect } from 'react';

import { KEYCODES } from 'a/data/constants';

const focusableElements = '[role="button"]:not([tabindex="-1"]), button:not([tabindex="-1"])';

const useFocusTrap = () => {
  const elementRef = useRef();

  const findFocusableElements = () => elementRef.current?.querySelectorAll(focusableElements) || [];

  const focusFirstElement = () => {
    const [firstElement] = findFocusableElements();

    if (firstElement) {
      firstElement.focus();
    }
  };

  const isElementActive = (element) => element && document.activeElement === element;

  const handleKeyDown = (e) => {
    const isTabPressed = e.key === KEYCODES.TAB;
    const allFocusableElements = findFocusableElements();

    if (!isTabPressed || !allFocusableElements?.length) {
      return;
    }

    const [firstFocusableElement] = allFocusableElements;
    const lastFocusableElement = allFocusableElements[allFocusableElements.length - 1];

    if (e.shiftKey) {
      if (isElementActive(firstFocusableElement)) {
        lastFocusableElement.focus();
        e.preventDefault();
      }
      return;
    }

    if (isElementActive(lastFocusableElement)) {
      firstFocusableElement.focus();
      e.preventDefault();
    }
  };

  useEffect(() => {
    focusFirstElement();

    elementRef.current?.addEventListener('keydown', handleKeyDown);

    return () => elementRef.current?.removeEventListener('keydown', handleKeyDown);
  }, []);

  return elementRef;
};

export default useFocusTrap;
